import React, { useEffect, useRef } from "react";
import videojs from "video.js";

import { findVideo } from "./admin/utils";

const useVideoJS = videoJsOptions => {
  const videoNode = useRef(null);

  const { sections } = videoJsOptions;
  const { idCurrentVideo } = videoJsOptions;
  const { prevVideo } = videoJsOptions;
  const { nextVideo } = videoJsOptions;
  const { autoAdvanceVideo, previousVideo } = videoJsOptions;
  const { autoplay, controls, nextSection, videoUrl } = videoJsOptions;
  // const { changes, calculeProgress } = videoJsOptions;

  useEffect(() => {
    const sources = [{ src: videoUrl }];

    const player = videojs(
      videoNode.current,
      {
        autoplay,
        controls,
        sources,
        sections,
        idCurrentVideo,
        autoAdvanceVideo,
        previousVideo,
        prevVideo,
        nextVideo,
        nextSection
        // changes,
        // calculeProgress,
      },
      () => {}
    );

    player.responsive(true);

    //Including prev and next buttons
    const Button = videojs.getComponent("Button");

    let NextButton = videojs.extend(Button, {
      constructor: function() {
        Button.apply(this, arguments);
        this.addClass("vjs-icon-next-item");
        this.addClass("hide"); //Hide control-text box
      },

      handleClick: function() {
        autoAdvanceVideo(sections);
      }
    });

    let PrevButton = videojs.extend(Button, {
      constructor: function() {
        Button.apply(this, arguments);
        this.addClass("vjs-icon-previous-item");
        this.addClass("hide"); //Hide control-text box
      },

      handleClick: function() {
        previousVideo(sections);
      }
    });

    videojs.registerComponent("PrevButton", PrevButton);
    videojs.registerComponent("NextButton", NextButton);

    player.addChild("NextButton");
    player.addChild("PrevButton");

    //Show and Hide Prev and Next Button

    player.on("mouseenter", function(event) {
      player.getChild("PrevButton").removeClass("vjs-user-inactive");
      player.getChild("PrevButton").removeClass("vjs-playing");
      player.getChild("NextButton").removeClass("vjs-user-inactive");
      player.getChild("NextButton").removeClass("vjs-playing");
    });

    player.on("mouseleave", function(event) {
      player.getChild("PrevButton").addClass("vjs-user-inactive");
      player.getChild("PrevButton").addClass("vjs-playing");
      player.getChild("NextButton").addClass("vjs-user-inactive");
      player.getChild("NextButton").addClass("vjs-playing");
    });

    //Toggle content of PrevButton

    player.getChild("PrevButton").on("mouseenter", function() {
      player.getChild("PrevButton").removeClass("hide");
      player.getChild("PrevButton").addClass("show");

      if (prevVideo != null) {
        const video = findVideo(prevVideo, sections);

        player.getChild("PrevButton").controlText(video.name);
      }
    });

    player.getChild("PrevButton").on("mouseleave", function() {
      player.getChild("PrevButton").removeClass("show");
      player.getChild("PrevButton").addClass("hide");
      player.getChild("PrevButton").controlText("");
    });

    //Toggle content of NextButton

    player.getChild("NextButton").on("mouseenter", function() {
      player.getChild("NextButton").removeClass("hide");
      player.getChild("NextButton").addClass("show");

      if (nextVideo !== null) {
        const video = findVideo(nextVideo, sections);

        player.getChild("NextButton").controlText(video.name);
      }
    });

    player.getChild("NextButton").on("mouseleave", function() {
      player.getChild("NextButton").removeClass("show");
      player.getChild("NextButton").addClass("hide");
      player.getChild("NextButton").controlText("");
    });

    //Including subtitles and captions

    player.on("loadedmetadata", function() {
      const video = findVideo(idCurrentVideo, sections);
      if (video.textTracks && video.textTracks.length > 0) {
        for (let i = 0; i < video.textTracks.length; i++) {
          this.addRemoteTextTrack(
            {
              label: video.textTracks[i].label,
              src: video.textTracks[i].source,
              srcLang: video.textTracks[i].language,
              kind: video.textTracks[i].captions
            },

            true
          );
        }
      }
    });

    player.on("timeupdate", function() {
      const video = findVideo(idCurrentVideo, sections);
      if (
        player.currentTime() / player.duration() >= 0.95 &&
        video.isCompleted === false
      ) {
        // changes(idCurrentVideo);
      }
    });

    player.on("ended", () => {
      autoAdvanceVideo(sections);
      // calculeProgress(sections);
    });

    return () => {
      player.dispose();
    };
  }, [
    idCurrentVideo,
    nextVideo,
    prevVideo,
    sections,
    autoAdvanceVideo,
    previousVideo,
    autoplay,
    controls,
    nextSection,
    videoUrl
    // calculeProgress
    // changes
  ]);

  return (
    <div data-vjs-player key={idCurrentVideo}>
      <video
        ref={videoNode}
        className="video-js vjs-big-play-centered  vjs-fluid"
      />
    </div>
  );
};
export default useVideoJS;
